exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?minimize!./assets/font/stylesheet.css"), "");
exports.i(require("-!../node_modules/css-loader/index.js?minimize!./assets/css/style.css"), "");
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@500;700&display=swap);", ""]);

// module
exports.push([module.id, "#app[data-v-4e6dfe35]{min-height:100vh}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e6dfe35","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 44
// module chunks = 8